import { useCallback } from "react";

import { Ellipsis, Eye } from "lucide-react";

import { Spinner } from "../spinner";
import { cn } from "@/shared/lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../dropdown-menu";
import { useToast } from "@/shared/hooks/useToast";

interface BlurredInfoProps {
  value: string;
  isPending?: boolean;
  isSuccess?: boolean;
  placeholder?: string;
  onRefetch?: () => void;
  height?: number;
}

export const BlurredInfo = ({
  value,
  isPending = false,
  isSuccess = true,
  placeholder,
  onRefetch,
  height = 12,
}: BlurredInfoProps) => {
  const { toast } = useToast();
  // const [showed, setShowed] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value).then(() => {
      toast({
        title: "Скопировано в буфер обмена",
      });
    });
  }, [toast, value]);

  const handleRefetch = useCallback(() => {
    onRefetch?.();
    toast({
      title: "Обновлено",
    });
  }, [onRefetch]);

  // const handleShow = useCallback(() => {
  //   setShowed(true);
  //   handleRefetch();
  // }, []);

  return (
    <div
      className={`border-input relative flex h-${height.toString()} w-full items-center rounded-md border-[1px] px-4 py-2`}
    >
      <div
        className={cn(
          "w-full text-center font-semibold text-textColor transition",
          !isSuccess ? "select-none blur-sm" : "blur-none",
        )}
      >
        {value || placeholder}
      </div>

      {!isSuccess && (
        <div className="absolute flex h-full w-full items-center justify-center">
          <div
            onClick={isPending ? undefined : handleRefetch}
            className={cn(
              "border-input -translate-x-1/2 items-center justify-center rounded-lg border-[1px] bg-white p-1",
              !isPending ? "cursor-pointer" : "",
            )}
          >
            {isPending ? <Spinner size="small" /> : <Eye opacity={0.7} />}
          </div>
        </div>
      )}
      {isSuccess && (
        <div className="absolute right-0 -translate-x-4 translate-y-1">
          <DropdownMenu>
            <DropdownMenuTrigger>
              <Ellipsis
                opacity={0.7}
                size="20px"
                className="stroke-textColor"
                onClick={onRefetch}
              />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onClick={handleCopy}>
                Копировать
              </DropdownMenuItem>
              {onRefetch && (
                <DropdownMenuItem onClick={handleRefetch}>
                  Обновить
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
    </div>
  );
};
